import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@gsa/afp-component-library';
import { enDashUnicode } from '../../utilities/constants';

const TITLE = {
  COMPLY: 'Comply yes/no',
  FREE_TEXT: 'Free text',
  NUM_ANY: 'Numeric',
};

export const getMinimumValue = (
  { inputTypeCode, criteriaTitle, unitTitle, lowerBound, upperBound },
  defaultValue = null,
) => {
  switch (inputTypeCode?.toLowerCase()) {
    case 'c': // Comply yes/no
      return TITLE.COMPLY;
    case 'f': // Free text
      return TITLE.FREE_TEXT;
    case 'n': // Numerical
      if (criteriaTitle === 'Any' && unitTitle)
        return `${TITLE.NUM_ANY} - ${unitTitle}`;
      if (lowerBound && unitTitle && criteriaTitle)
        return `${criteriaTitle} ${lowerBound} ${unitTitle}`;
      return defaultValue;
    case 'r': // Numerical range
      if (lowerBound && upperBound && unitTitle)
        return `${lowerBound}-${upperBound} ${unitTitle}`;
      return defaultValue;
    default: // case 'p' - predefined value
      return defaultValue;
  }
};

export const PredeterminedInput = ({ preDefinedValue = { value: [] } }) => {
  const [expanded, setExpanded] = useState(false);

  const iconName = expanded ? 'expand_less' : 'expand_more';
  const listClass = `margin-top-2 ${expanded ? 'expand-predetermined' : 'expandable-list'}`;

  return (
    <div>
      <Button
        variant="unstyled"
        onClick={() => setExpanded(!expanded)}
        label="Predetermined value"
        rightIcon={{ name: iconName }}
      />
      <div className={listClass}>
        {preDefinedValue?.value?.map((v) => (
          <div key={v}>{v}</div>
        ))}
      </div>
    </div>
  );
};

const PreDefinedValueShape = {
  value: PropTypes.arrayOf(PropTypes.string),
};

PredeterminedInput.propTypes = {
  preDefinedValue: PropTypes.objectOf(PreDefinedValueShape),
};

export const InputType = ({
  row: {
    original: {
      inputType,
      criteria,
      unit,
      lowerBound,
      upperBound,
      preDefinedValue,
    },
  },
}) => {
  if (inputType?.code?.toLowerCase() === 'p')
    return <PredeterminedInput preDefinedValue={preDefinedValue} />;

  const displayValue = getMinimumValue(
    {
      inputTypeCode: inputType?.code,
      criteriaTitle: criteria?.title,
      unitTitle: unit?.title,
      lowerBound,
      upperBound,
    },
    enDashUnicode,
  );
  return <>{displayValue}</>;
};

const CodeTitleShape = PropTypes.shape({
  code: PropTypes.string,
  title: PropTypes.string,
});

InputType.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      inputType: CodeTitleShape,
      criteria: CodeTitleShape,
      unit: CodeTitleShape,
      lowerBound: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      upperBound: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      preDefinedValue: PropTypes.objectOf(PreDefinedValueShape),
    }),
  }).isRequired,
};
